export default __webpack_public_path__ + "static/media/temple.828b963e.jpeg";